<div class=" row mt-3">
    <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Client Id</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>User Name</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Password(Set)</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Transaction Password(Unset)</mat-label>
        <input matInput type="text" name="name" autocomplete="off">
      </mat-form-field>
    
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Transaction HAP</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>

  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Profile</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Fare PCC</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Search PCC</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Transaction Profile</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
 
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Url</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>IATA Number</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
 
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Supplier Currency</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
  <mat-form-field class="col-md-4" appearance="outline">
    <mat-label>Queue Number</mat-label>
    <input matInput type="text" name="name" autocomplete="off">
  </mat-form-field>
  

</div> 